import { heroLead, heroSideCards, heroStats } from "@/mocks/home";

export default function HeroGrid() {
  return (
    <section className="mx-auto w-full max-w-[1280px] px-4 pb-6 pt-10 md:px-6 md:pt-16">
      <div className="max-w-3xl">
        <span className="inline-flex items-center gap-2 rounded-full border border-accent-200 bg-accent-50 px-3 py-1 text-xs font-medium text-accent-700">
          <span className="flex h-3.5 w-3.5 items-center justify-center">
            <i className="ri-flashlight-line"></i>
          </span>
          本期主推 · 09-10 更新
        </span>
        <h2 className="mt-4 font-heading text-3xl font-bold leading-tight tracking-tight text-foreground-950 md:text-5xl">
          爆料黑料合集，
          <span className="text-primary-600">一次看够不迷路</span>
        </h2>
        <p className="mt-4 max-w-2xl text-sm leading-relaxed text-foreground-600 md:text-base">
          这里汇总了近期最热门的黑料大合集与黑料打包资源，按人物、事件分类整理。上排是主推与并列卡片，往下依次是合集索引、话题墙和整理流，越往下信息越密，翻到哪都能接着看。
        </p>
      </div>

      <div className="mt-8 grid grid-cols-1 gap-4 lg:grid-cols-12">
        <a
          href="#feed"
          className="group relative col-span-1 block cursor-pointer overflow-hidden rounded-lg bg-foreground-950 lg:col-span-6"
        >
          <div className="relative h-[280px] w-full md:h-[420px]">
            <img
              src={heroLead.image}
              alt="爆料黑料合集主推封面，黑料大合集与黑料打包资源整理"
              title="爆料黑料 - 黑料大合集主推封面"
              className="h-full w-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-foreground-950 via-foreground-950/40 to-foreground-950/5"></div>
            <div className="absolute inset-x-0 bottom-0 p-5 md:p-7">
              <span className="inline-flex items-center gap-1.5 rounded-full bg-accent-500 px-2.5 py-1 text-xs font-medium text-background-50">
                <span className="flex h-3.5 w-3.5 items-center justify-center">
                  <i className="ri-fire-fill"></i>
                </span>
                {heroLead.category}
              </span>
              <h3 className="mt-3 font-heading text-xl font-bold leading-snug text-background-50 md:text-3xl">
                {heroLead.title}
              </h3>
              <p className="mt-2 hidden max-w-xl text-sm leading-relaxed text-background-200 sm:block">
                {heroLead.excerpt}
              </p>
              <div className="mt-4 flex flex-wrap items-center gap-x-3 gap-y-2 text-xs text-background-200/80">
                {heroLead.tags.map((tag) => (
                  <span
                    key={tag}
                    className="rounded-full border border-background-50/25 px-2.5 py-1"
                  >
                    {tag}
                  </span>
                ))}
                <span className="ml-auto hidden text-background-200/70 md:inline">
                  {heroLead.meta.items} 条内容 · {heroLead.meta.heat} 热度 ·{" "}
                  {heroLead.meta.updated}
                </span>
              </div>
            </div>
          </div>
        </a>

        <div className="col-span-1 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:col-span-3 lg:grid-cols-1">
          {heroSideCards.slice(0, 2).map((card) => (
            <a
              key={card.id}
              href="#collections"
              className="group flex cursor-pointer gap-3 overflow-hidden rounded-lg border border-background-200/80 bg-background-50 p-3 transition-colors hover:border-primary-300"
            >
              <div className="h-20 w-24 shrink-0 overflow-hidden rounded-md">
                <img
                  src={card.image}
                  alt={`${card.title} - 爆料黑料合集整理`}
                  title={`${card.title} - 黑料汇总`}
                  className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
              </div>
              <div className="flex min-w-0 flex-col justify-between py-0.5">
                <div>
                  <span className="text-[11px] font-medium text-primary-600">
                    {card.category}
                  </span>
                  <h3 className="mt-1 line-clamp-2 text-sm font-semibold leading-snug text-foreground-950">
                    {card.title}
                  </h3>
                </div>
                <span className="text-[11px] text-foreground-500">{card.meta}</span>
              </div>
            </a>
          ))}
        </div>

        <div className="col-span-1 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:col-span-3 lg:grid-cols-1">
          {heroSideCards.slice(2, 4).map((card) => (
            <a
              key={card.id}
              href="#collections"
              className="group flex cursor-pointer gap-3 overflow-hidden rounded-lg border border-background-200/80 bg-background-50 p-3 transition-colors hover:border-primary-300"
            >
              <div className="h-20 w-24 shrink-0 overflow-hidden rounded-md">
                <img
                  src={card.image}
                  alt={`${card.title} - 爆料黑料合集整理`}
                  title={`${card.title} - 黑料汇总`}
                  className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
              </div>
              <div className="flex min-w-0 flex-col justify-between py-0.5">
                <div>
                  <span className="text-[11px] font-medium text-primary-600">
                    {card.category}
                  </span>
                  <h3 className="mt-1 line-clamp-2 text-sm font-semibold leading-snug text-foreground-950">
                    {card.title}
                  </h3>
                </div>
                <span className="text-[11px] text-foreground-500">{card.meta}</span>
              </div>
            </a>
          ))}
        </div>
      </div>

      <div className="mt-4 grid grid-cols-2 gap-x-4 gap-y-5 rounded-lg border border-background-200/80 bg-background-100/70 p-5 md:grid-cols-4 md:p-6">
        {heroStats.map((stat) => (
          <div key={stat.label} className="flex flex-col">
            <span className="font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
              {stat.value}
              <span className="ml-0.5 text-sm font-medium text-foreground-500">
                {stat.unit}
              </span>
            </span>
            <span className="mt-1 text-xs text-foreground-600">{stat.label}</span>
          </div>
        ))}
      </div>
    </section>
  );
}